// SHI-383 — some quiz answers are objects/arrays (e.g. the focus-priority ranking added in SHI-360:
// [{rank,name,label,answerCode}]). Rendered raw they crash React (#31) or show "[object Object]".
// Normalize them to readable text; scalar/HTML-string answers pass through unchanged.
export const formatQuizAnswer = (a) => {
  if (a === null || a === undefined) return '';
  if (Array.isArray(a)) {
    if (a.every((x) => x && typeof x === 'object' && 'label' in x)) {
      return a.map((x) => `${x.rank ? `${x.rank}. ` : ''}${x.label}`).join(', ');
    }
    return JSON.stringify(a);
  }
  if (typeof a === 'object') return JSON.stringify(a);
  return a;
};
